import logger from "@/lib/logger";
export default function debugLog(...args) {
  logger.debug("[debug]", ...args);
}
